import { ImageField } from "./image-field";
import { CharacterCount } from "./character-count";

/**
 * The Featured Story's own fields: the story text and its images.
 *
 * Both limits are props, from appsettings via the view. The image hint reads "You can add a
 * maximum of N images per story" in the design, with N interpolated rather than typed — the design
 * says 4 because that is what MaxStoryImages happens to be today.
 */
export function StoryFields({ form, update, errors, settings, copy }) {
  return (
    <>
      <div className="member-profile-editor__field">
        <label className="member-profile-editor__field-label" htmlFor="story-body">
          {copy.storyBodyLabel}
        </label>

        <p className="member-profile-editor__hint">{copy.storyBodyHint}</p>

        <textarea
          id="story-body"
          className="member-profile-editor__textarea"
          data-testid="story-body"
          rows={8}
          value={form.bodyHtml}
          onChange={(event) => update({ bodyHtml: event.target.value })}
        />

        {/* No maxLength attribute. The server counts VISIBLE characters, so once the value can
            carry markup the two numbers stop meaning the same thing - the same reason the bio
            field dropped its maxLength. The counter warns; the server decides. */}
        <CharacterCount value={form.bodyHtml} max={settings.bodyMaxLength} testId="story-body-counter" />

        {errors.body ? (
          <p className="member-profile-editor__error" role="alert" data-testid="error-body">
            {errors.body}
          </p>
        ) : null}
      </div>

      <ImageField
        label={copy.storyImagesLabel}
        hint={(copy.storyImagesHint ?? "").replace("{0}", settings.maxImages)}
        images={form.images}
        onChange={(images) => update({ images })}
        maxImages={settings.maxImages}
        maxFileSizeBytes={settings.imageMaxFileSizeBytes}
        testId="story-images"
        error={errors.images}
        copy={copy}
        source="story"
        previews={[
          { label: "Story slide", aspect: 3 / 4 },
          { label: "Editor tile", aspect: 1 },
        ]}
      />
    </>
  );
}
